// @ts-nocheck
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const SpaceWrestler = styled.div`
    display: flex;
    flex-direction: ${props => props.flexDirectionSpaceWrestler || 'row'};
    align-items: center;
    justify-content: ${props => props.justifyContentSpaceWrestler || 'space-around'};
    width: 100%;
    height: ${props => props.height || '50%'};
    padding: 5px 0;
    column-gap: 5px;
    row-gap: ${props => props.rowGapSpaceWrestler || '0px'};

    & h6.name-wrestler {
        width: ${props => props.widthNameWrestler || `calc(100% - ${props.widthPixelAvatar || '40px'})`};
        font-size: ${props => props.fontSize || '8px'};
        color: white;
        text-align: center;
        margin: 0;
        padding: 0;
        font-weight: 500;
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

const BoxAvatar = styled.div`
    display: flex;
    align-items: center;
    width: ${props => props.widthPixelAvatar || '40px'};
    height: ${props => props.heightPixelAvatar || '40px'};
    border: 1px solid white;

    &.left {
        justify-content: flex-start;
    }

    &.right {
        justify-content: flex-end;
    }

    & img.box-avatar-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;



function GenericMobileRenderWrestlerWhenNumberInSide({ 
    wrestler, 
    side,
    heightCardPercentage,
    heightPixelAvatar,
    widthPixelAvatar,
    fontSize,
    flexDirectionSpaceWrestler,
    justifyContentSpaceWrestler,
    rowGapSpaceWrestler,
    widthNameWrestler,
}) {
    const navigate = useNavigate();

    function navigateToWrestler(wrestler) {
        navigate(`/wrestlers/i_${wrestler.id}_d_${wrestler.name}`);
    }
    
    function renderWrestlersLeftSide(wrestler) {
        return (
            <SpaceWrestler 
             className='space-wrestler left'
             onClick={() => navigateToWrestler(wrestler)}
             height={heightCardPercentage}
             fontSize={fontSize}
             flexDirectionSpaceWrestler={flexDirectionSpaceWrestler}
             justifyContentSpaceWrestler={justifyContentSpaceWrestler}
             rowGapSpaceWrestler={rowGapSpaceWrestler}
             widthNameWrestler={widthNameWrestler}
            >
                <BoxAvatar 
                 className='box-avatar'
                 heightPixelAvatar={heightPixelAvatar}
                 widthPixelAvatar={widthPixelAvatar}
                >
                    <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} className='box-avatar-image' />
                </BoxAvatar>
                    <h6 className='name-wrestler'>{wrestler.name}</h6>
            </SpaceWrestler>
        )
    }
    
    function renderWrestlersRightSide(wrestler) {
        return (
            <SpaceWrestler 
             className='space-wrestler right'
             onClick={() => navigateToWrestler(wrestler)}
             height={heightCardPercentage}
             fontSize={fontSize}
             flexDirectionSpaceWrestler={flexDirectionSpaceWrestler}
             justifyContentSpaceWrestler={justifyContentSpaceWrestler}
             rowGapSpaceWrestler={rowGapSpaceWrestler}
             widthNameWrestler={widthNameWrestler}
            >
                <h6 className='name-wrestler'>{wrestler.name}</h6>
                <BoxAvatar 
                 className='box-avatar'
                 heightPixelAvatar={heightPixelAvatar}
                 widthPixelAvatar={widthPixelAvatar}
                >
                    <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} className='box-avatar-image' />
                </BoxAvatar>
            </SpaceWrestler>
        )
    }


    return (
        side === 'left' ? renderWrestlersLeftSide(wrestler) : renderWrestlersRightSide(wrestler)
    )
}

export default GenericMobileRenderWrestlerWhenNumberInSide;